import { DefaultBaseObjectFormGroupMapper } from './default-base-object-form-group.mapper';
import { BaseObject } from '../_models/base-object';
import { hasNumericValue } from '../_utils/utils';
import { Splitter } from '../_models/_unit-operations/splitter';

export abstract class BaseSplitterFormGroupMapper extends DefaultBaseObjectFormGroupMapper {
  override map(source: BaseObject, destination: BaseObject) {
    super.map(source, destination);
    const sourcePlainObject = source as Splitter;
    const destinationInstance = destination as Splitter;

    destinationInstance.isOptimizable = !!sourcePlainObject.isOptimizable;
    this.mapRatioVariables(sourcePlainObject, destinationInstance);
  }

  mapRatioVariables(source: Splitter, destination: Splitter) {
    for (let i = 0; i < source.distributionRatioVariables.length; i++) {
      const sourceValue = source.distributionRatioVariables[i].value;

      // eslint-disable-next-line max-len
      destination.distributionRatioVariables[i].value = hasNumericValue(sourceValue) ? +sourceValue : undefined; // source.distributionRatioVariables[i].value;
    }
  }

  override ignoreForAutoMapping(key: string, source: BaseObject, destination: BaseObject): boolean {
    const sourcePlainObject = source as Splitter;
    return (
      super.ignoreForAutoMapping(key, source, destination) ||
      source[key] === sourcePlainObject.distributionRatioVariables
    );
  }
}
